/* eslint-disable array-callback-return*/

import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { makeStyles } from "@material-ui/core/styles";
import { instance3 } from "App/constants";
import { dateTimePickerToValidDate, isNull } from "App/utils/helpers";
export const urlGet = "/wmsfarmasi/master/masterBarang/list1";

const paramsItemValid = [
  {
    mask: "jenis_layanan_id",
    valid: "id_jenis_layanan",
  },
  {
    mask: "barang_id",
    valid: "barang_id",
  },
  {
    mask: "penjualan_id",
    valid: "penjualan_id",
  },
  {
    mask: "tanggal_awal",
    valid: "tanggal_awal",
  },
  {
    mask: "tanggal_akhir",
    valid: "tanggal_akhir",
  },
  {
    mask: "unit_id",
    valid: "unit_id",
  },
  {
    mask: "produsen_id",
    valid: "produsen_id",
  },
  {
    mask: "nama_rm",
    valid: "nama_rm",
  },
  {
    mask: "dokter_id",
    valid: "dokter_id",
  },
  {
    mask: "id_jasa",
    valid: "id_jasa",
  },
  {
    mask: "fasilitas_id",
    valid: "fasilitas_id",
  },
  {
    mask: "id_rikjang",
    valid: "id_rikjang",
  },
  {
    mask: "paket_id",
    valid: "paket_id",
  },
  {
    mask: "id_type_of_care",
    valid: "id_type_of_care",
  },
];

const createValidQueryParams = (paramsValid, formFilter) => {
  const query = [];

  paramsValid.map((item) => {
    const checkField = formFilter[item.mask];
    if (!isNull(checkField)) {
      if (item.mask === "tanggal_awal" || item.mask === "tanggal_akhir") {
        query.push(`${item.valid}=${dateTimePickerToValidDate(checkField)}`);
      } else {
        query.push(`${item.valid}=${checkField}`);
      }
    }
  });

  return query.join("&");
};

export const posisiSelect = [
  {
    value: 1,
    label: "Non Posisi",
  },
  {
    value: 2,
    label: "First Child Of",
  },
  {
    value: 3,
    label: "Last Child Of",
  },
  {
    value: 4,
    label: "Prev Sibling Of",
  },
  {
    value: 5,
    label: "Next Sibling Of",
  },
];

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
};

export const STYLE_DEPARTEMEN = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "kode",
    disablePadding: true,
    label: "KODE",
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
];

export const getTabItem = async (
  formFilter,
  pages,
  limit,
  url = "/penjualan/laporanItem"
) => {
  try {
    const queryParams = createValidQueryParams(paramsItemValid, formFilter);
    const api = await instance3.get(
      `${url}?jumlah=${limit}&halaman=${pages}&${queryParams}`
    );
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getRootDepartemen = async () => {
  try {
    const api = await instance3.post(urlGet, {});

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
